import type { EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import type { ComponentType } from 'react';

export const CLEAR_FORMATTING_PLUGIN_ID = 'clearFormatting' as const;
export type ClearFormattingPluginID = typeof CLEAR_FORMATTING_PLUGIN_ID;

export type ClearFormattingPluginOptions = Readonly<EditorPluginOptions>;

export type ClearFormattingPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    ClearFormattingPluginOptions & {
      pluginID: ClearFormattingPluginID;
      hotkey: string;
      icon: ComponentType<any>;
      pluginName: string;
    }
>;
